import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { EmployeeService } from '../employee.service'
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-employee-table',
  templateUrl: './employee-table.component.html',
  styleUrls: ['./employee-table.component.scss']
})
export class EmployeeTableComponent implements OnInit {
  nameFilter = new FormControl('');
  mobileFilter = new FormControl('');
  filterValues = {
    'id':'',
    'first_name':'',
    'mobile':'',
    'office':''
  };
  
  dataSource: any;
  displayedColumns: string[] = ['id', 'name', 'mobile', 'gender_name','taluk_name','district_name' ,'office', 'role', 'joining_date', 'union_name'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;


  constructor(private global: GlobalService, private http : HttpService, public employeeService: EmployeeService) { 
    this.global.set_master_page_title = 'Employee';
    this.getEmployee();
    this.employeeService.downloadEmployee.subscribe((taluk) => {
      console.log(taluk);
      if (taluk) {
        this.getEmployee();
      }
    });
  }
  
  getEmployee() {
    this.http.getEmployee().subscribe((data: Employee[]) => {
      console.log(data);
      // this.dataSource = new MatTableDataSource<Employee>(data);
      // this.dataSource.sort = this.sort;
      this.dataSource = data;
      // this.dataSource.filterPredicate = this.createFilter();
    }, (error) => {
      console.log(error);
    });
  }

  registerEmployee() {
    this.ShowEmployeeRegister();
    this.employeeService.employeeUpdate.emit(null);
    this.employeeService.set_employee_data = null;
  }

  editEmployee(element) {
    this.ShowEmployeeRegister();
    this.employeeService.employeeUpdate.emit(element);
    this.employeeService.set_employee_data = element;
  }

  hideEmployeeRegister() {
    this.employeeService.is_display_employee_register_component = false;
  }

  ShowEmployeeRegister() {
    this.employeeService.is_display_employee_register_component = true;
  }

  ngOnInit() {
    console.log('ng funct');
    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.first_name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    // code
    this.mobileFilter.valueChanges
      .subscribe(
        mobile => {
          this.filterValues.mobile = mobile;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  createFilter():
  (data: any, filter: string) => boolean {
  console.log('filter')
  let filterFunction = function (data, filter): boolean {
    let searchTerms = JSON.parse(filter);
    return data.mobile.indexOf(searchTerms.mobile) !== -1
      && data.first_name.toString().toLowerCase().indexOf(searchTerms.first_name.toString().toLowerCase()) !== -1
  }
  return filterFunction;
}

}

export interface Employee {
  id: number;
  first_name: string;
}